import { render, staticRenderFns } from "./partenr-income-deposit.vue?vue&type=template&id=18ae1ba4&scoped=true&"
import script from "./partenr-income-deposit.vue?vue&type=script&lang=js&"
export * from "./partenr-income-deposit.vue?vue&type=script&lang=js&"
import style0 from "./partenr-income-deposit.vue?vue&type=style&index=0&id=18ae1ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae1ba4",
  null
  
)

export default component.exports